export class ClientJsonParser {
	static DateRegex = /^\/Date\(((?:-)?\d+)\)\/$/;
	static parse = (key: string, value: any) => {
		//парсинг даты
		if (typeof value === 'string') {
			const match = this.DateRegex.exec(value);
			if (match) {
				return new Date(parseInt(match[1], 10));
			}
		}

		//кастомные методы объекта которые могут вызываться в скриптах
		if (value && !!value['$redocDfType']) {
			value['ToString'] = () => {
				return value['$ToStringStringValue'];
			};
			value['toString'] = () => {
				return value['$ToStringStringValue'];
			};
		}

		return value;
	};
}
